var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"o-Container":"","o-Container-App":""}},[_c('div',{staticClass:"lancooHead"},[_c('div',{staticClass:"title-panel"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('iframe',{attrs:{"name":"lanncooFrame"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0abdf241","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/App/Campus/Login/LancooPage.vue
// module id = null
// module chunks = 